import React from "react";
import Lozenge from "../components/BaseUI/Lozenge";
import { getApprovalResultBadge } from "./approvalSteps";

const ApprovalResultBadge = ({ item, className }) => {
  const badge = getApprovalResultBadge(item);
  return (
    <Lozenge appearance={badge.appearance} title={badge.title} className={className}>
      {badge.label}
    </Lozenge>
  );
};

export default ApprovalResultBadge;
